import { OrgId } from "@hex/common";
import React, { useCallback } from "react";
import styled from "styled-components";

import { Routes } from "../../route/routes";
import MicrosoftLogo from "../../static/integration/microsoft-logo.inline.svg";

import { LoginOption } from "./LoginOption";

export const MicrosoftIcon = styled(MicrosoftLogo)`
  width: 22px;
  height: 22px;
`;

export interface AzureLoginProps {
  authQueryParams: Record<string, string>;
  embedded: boolean;
  onComplete: () => void;
  onSubmit: () => void;
  orgId?: OrgId;
}

export const AzureLogin: React.ComponentType<AzureLoginProps> = React.memo(
  function AzureLogin({
    authQueryParams,
    embedded,
    onComplete,
    onSubmit,
    orgId,
  }) {
    const azureCallback = useCallback(async () => {
      onSubmit();
      const url = Routes.AZURE_AUTH.getUrl({
        orgId,
        queryParams: authQueryParams,
      });
      if (embedded) {
        window.open(url, "_blank");
        onComplete();
      } else {
        window.location.href = url;
      }
    }, [authQueryParams, embedded, orgId, onSubmit, onComplete]);

    return (
      <LoginOption icon={<MicrosoftLogo />} onClick={azureCallback}>
        Log in with <span>Microsoft</span>
      </LoginOption>
    );
  },
);
